import React from "react";
import {FormattedMessage} from "react-intl";
import RadioButtonGroupSurfaceFinish from "../../RadioButtonGroup/RadioButtonSurfaceFinish/RadioButtonGroup4";
import {Link} from "react-router-dom";

let surface = [
    {
        id: 0,
        checked: true,
        name: "surfaceFinish",
        text: <FormattedMessage id="app.pcb-quotation.pcb-surface-finish-1"
                                defaultMessage="HASL(with lead)"
                                description=""/>,
        disabled:false
    },
    {
        id: 1,
        checked: false,
        name: "surfaceFinish",
        text: <FormattedMessage id="app.pcb-quotation.pcb-surface-finish-2"
                                defaultMessage="LeadFree HASL+RoHS"
                                description=""/>,
        disabled:false
    },
    {
        id: 2,
        checked: false,
        name: "surfaceFinish",
        text: <FormattedMessage id="app.pcb-quotation.pcb-surface-finish-3"
                                defaultMessage="ENIG-RoHS"
                                description=""/>,
        disabled:false
    },
];

let surfaceDisabled = [
    {
        id: 0,
        checked: false,
        name: "surfaceFinish",
        text: <FormattedMessage id="app.pcb-quotation.pcb-surface-finish-1"
                                defaultMessage="HASL(with lead)"
                                description=""/>,
        disabled:true
    },
    {
        id: 1,
        checked: false,
        name: "surfaceFinish",
        text: <FormattedMessage id="app.pcb-quotation.pcb-surface-finish-2"
                                defaultMessage="LeadFree HASL+RoHS"
                                description=""/>,
        disabled:true
    },
    {
        id: 2,
        checked: true,
        name: "surfaceFinish",
        text: <FormattedMessage id="app.pcb-quotation.pcb-surface-finish-3"
                                defaultMessage="ENIG-RoHS"
                                description=""/>,
        disabled:false
    },
];

const SurfaceFinish = (props) => {
    let thickness = props.pcbParams.thickness;
    let pcbSurface = surface.map((item) => {
        item.checked = (item.id === props.selectedId);
        if((thickness === 0.4 && item.id === 0) || (thickness === 0.4  && item.id === 1)){
            item.disabled = true;
        }else {
            item.disabled = false;
        }

        return item;
    });

    return (
        <div className="row">
            <div className="col-md-12 no-padding">
                <div className="pcb-details-div">
                    <div className="col-md-3 text-right content-item-heading">
                        <FormattedMessage id="app.pcb-quotation.pcb-surface-finish"
                                          defaultMessage="Surface Finish"
                                          description=""
                        />
                        &nbsp; &nbsp;
                        <Link id="surfFinish-qLink"
                            to={{pathname:"https://kitcutlabo.com/processing/"}} target="_self"
                            className="glyphicon glyphicon-question-sign question-link"></Link>
                    </div>
                    <div className="btn-group col-md-9 pcb-details-div-items">
                        {(props.pcbParams.thickness === 0.4 || props.pcbParams.goldFinger === 2) ?
                            <RadioButtonGroupSurfaceFinish data={surfaceDisabled} getParams={props.setPCBParams}/>
                            :
                           ''
                        }
                        {(props.pcbParams.thickness !== 0.4 && props.pcbParams.goldFinger === 0) ?
                            <RadioButtonGroupSurfaceFinish data={pcbSurface} getParams={props.setPCBParams}/>
                            :
                           ''
                        }
                    </div>
                </div>
            </div>
        </div>
    )
};

export default SurfaceFinish;



// WEBPACK FOOTER //
// ./src/components/Site/QuotationForm/PCBQuotationForm/PCBQuotationFormFields/SurfaceFinish.js